import Assert from "tbAssert";

import oneLoginOidc from "tbClient/shims/oneLoginOidc";
import angularJwt from "angular-jwt";

import DependencyListBuilder from "tbClient/utility/DependencyListBuilder";
import MakePropsEnumerable from "tbClient/utility/MakePropsEnumerable";

import TbAuthCallbackModuleConstants from "tbClient/views/auth-callback/Constants";
import AuthServiceModuleConstants from "tbClient/services/auth/AuthConstants";
import extractDomain from "tbClient/utility/ExtractDomain";
import AuthService from "./AuthService";
import TbAppConfig from "tbClient/config/tb-app-config/TbAppConfig";

// eslint-disable-next-line no-unused-vars
import IdTokenClaimsInterceptor from "./IdTokenClaimsInterceptor";

class AuthServiceProvider {
    constructor(
        oneLoginOidcProvider,
        jwtOptionsProvider,
        $httpProvider,
        $injector
    ) {
        Assert.StrictAssert(oneLoginOidcProvider != null, "Missing or invalid OneLogin OIDC provider");
        Assert.StrictAssert(jwtOptionsProvider != null, "Missing or invalid jwt options angular provider");
        Assert.StrictAssert($httpProvider != null, "Missing or invalid $http provider");

        this._oneLoginProvider = oneLoginOidcProvider;
        this._jwtOptionsProvider = jwtOptionsProvider;
        this._httpProvider = $httpProvider;
        this._injector = $injector;

        this._tbAppConfigData = null;
    }

    configureAuth(appConfig) {

        if (appConfig instanceof TbAppConfig) {
            this._tbAppConfigData = appConfig;
        }
        else {
            throw new Error("Auth Service Provider Configuration: invalid app configuration provided.");
        }


        this._oneLoginProvider.init({
            clientID: this._tbAppConfigData.tbOneLoginClientId,
            domain: this._tbAppConfigData.tbOneLoginServer,
            responseType: "id_token token",  // Use implicit flow like OneLogin's official sample
            audience: this._tbAppConfigData.tbApiId,
            redirectUri: `${this._tbAppConfigData.tbClientAppUrl}/${TbAuthCallbackModuleConstants.stateUrl}`,
            postLogoutRedirectUri: this._tbAppConfigData.tbClientAppUrl,  // Add post-logout redirect URI
            scope: [
                "openid",
                "email",
                "profile",
                "groups",  // Standard groups scope for group membership
                "params"   // OneLogin-specific scope for custom parameters/claims
            ].join(" "),
            debugMode: this._tbAppConfigData.tbEnableDebugMode
        });

        const tbServerBaseExtractedDomain = extractDomain(this._tbAppConfigData.tbServerBaseUrl);
        const authWhiteListedDomains = [
            (tbServerBaseExtractedDomain != null ? tbServerBaseExtractedDomain : this._tbAppConfigData.tbServerBaseUrl)
        ];


        if (this._tbAppConfigData.tbEnableDebugMode) {
            //eslint-disable-next-line no-console
            console.debug("Auth White Listed Domains", authWhiteListedDomains);
        }
        this._jwtOptionsProvider.config({
            tokenGetter: () => localStorage.getItem(AuthServiceModuleConstants.storageKeys.accessTokenKey),
            whiteListedDomains: authWhiteListedDomains
        });

        // Register custom interceptors
        this._httpProvider.interceptors.push("jwtInterceptor");
        this._httpProvider.interceptors.push("IdTokenClaimsInterceptor");
    }

    get $get() {
        const generatedFactory = (...authServiceArgs) => new AuthService(...authServiceArgs);
        const annotatedFactory = [...AuthService.$inject, generatedFactory];
        return annotatedFactory;
    }
}

MakePropsEnumerable(AuthServiceProvider.prototype, [
    "$get"
]);

AuthServiceProvider.$inject = [
    "oneLoginOidcProvider",
    "jwtOptionsProvider",
    "$httpProvider",
    "$injector"
];

AuthServiceProvider.dependencies = DependencyListBuilder([
    AuthService.dependencies,
    [
        oneLoginOidc,
        angularJwt
    ]
]);

export default AuthServiceProvider;



//////////////////
// WEBPACK FOOTER
// ./src/services/auth/AuthServiceProvider.js
// module id = qx4K
// module chunks = 1